import { render } from "./TeamAnnouncements.vue?vue&type=template&id=578199cf&scoped=true"
import script from "./TeamAnnouncements.vue?vue&type=script&lang=js"
export * from "./TeamAnnouncements.vue?vue&type=script&lang=js"

import "./TeamAnnouncements.vue?vue&type=style&index=0&id=578199cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578199cf"]])

export default __exports__